import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import FieldEstimate_ConditionInput from "./condition-input"

const debug = false

export default class FieldTaskEstimate_ConditionForm extends FieldProto_ConditionForm {

    onChangeConditionType = (type: ConditionType) => {
        if (type !== ConditionType.NUMBER_BETWEEN) {
            this.onChangeValue(null)
        }
        this.onChangeType(type)
    }

    onChangeGreaterThanValue = (hours: number | null) => {
        const value = {...this.props.condition.value, greaterThan: hours}
        this.onChangeValue(value)
    }

    onChangeLessThanValue = (hours: number | null) => {
        const value = {...this.props.condition.value, lessThan: hours}
        this.onChangeValue(value)
    }

    renderConditionForm() {
        switch (this.props.condition.type) {

            case ConditionType.NUMBER_BETWEEN:
                return (
                    <div className="flex-row-left-top m-l-10">
                        <FieldEstimate_ConditionInput value       = {this.props.condition.value?.greaterThan ?? null}
                                                      onChange    = {this.onChangeGreaterThanValue}
                                                      placeholder = "Min"/>
                        <div className="ui5-txt-not-important-small h-36 fl-ac m-r-5 m-l-5">-</div>
                        <FieldEstimate_ConditionInput value       = {this.props.condition.value?.lessThan ?? null}
                                                      onChange    = {this.onChangeLessThanValue}
                                                      placeholder = "Max"/>
                    </div>
                )

            case ConditionType.NUMBER_LESS_THAN:
            case ConditionType.NUMBER_GREATER_THAN:
            case ConditionType.NUMBER_EQUALS:
                return (
                    <div className="flex-row-left-center m-l-10">
                        <FieldEstimate_ConditionInput value    = {this.props.condition.value ?? null}
                                                      onChange = {this.onChangeValue}/>
                    </div>
                )

            default:
                return null
        }
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeConditionType}/>

                {this.renderConditionForm()}
            </React.Fragment>
        )
    }
}
